module.exports = __webpack_public_path__ + "img/dropdown-icon.fff119b3.svg";